
import { Component, Vue } from 'vue-property-decorator'
import { AppMain } from './components'

@Component({
  name: 'LayoutWithFullHeight',
  components: {
    AppMain,
  }
})
export default class extends Vue {
}
